import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { MdClose, MdOutlineFileUpload } from 'react-icons/md';
import Modal from '../../components/modal';
import Input from '../../components/Input';
import Addnotes from '../notes/AddNotes';
import AddSale from '../Sale/AddSale';

const UpdateCources = ({ isModalOpen, setIsModalOpen, closeModal, getData }) => {
  const [planData, setPlanData] = useState({
    name: '',
    timePeriod: '',
    courseDuration: '',
    file: null,
    description: '',
    price: '',
    category: '',
    youtubeVideoLink: '',
    lessons: '',
    bulletPoints: [],
    additionalImages: []
  });

  console.log(planData);

  const [imagePreview, setImagePreview] = useState(null);
  const [additionalImagePreviews, setAdditionalImagePreviews] = useState([]);
  const [loading, setLoader] = useState(false);
  const [category, setCategory] = useState([]);
  const [bulletPointInput, setBulletPointInput] = useState('');

  useEffect(() => {
    if (getData) {
      setPlanData({
        name: getData.name || '',
        timePeriod: getData.periodType || '',
        courseDuration: getData.duration || '',
        file: null,
        description: getData.description || '',
        price: getData.price || '',
        category: getData.category || '',
        youtubeVideoLink: getData.youtubeVideoLink || '',
        lessons: getData.lesson || '',
        bulletPoints: getData.bulletPoints || [],
        additionalImages: getData.additionalImages
      });

      if (getData.image) {
        setImagePreview(getData.image);
      }
      if (getData.additionalImages && getData.additionalImages.length > 0) {
        setAdditionalImagePreviews(getData.additionalImages);
      }
    }
  }, [getData]);

  const isFormValid = () => {
    return (
      planData.name &&
      planData.timePeriod &&
      planData.courseDuration &&
      planData.price &&
      planData.lessons &&
      planData.category
    );
  };

  useEffect(() => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/admin/category', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        setCategory(data?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPlanData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPlanData((prev) => ({
        ...prev,
        file: file
      }));
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleClick = () => {
    document.getElementById('fileInput').click();
  };

  const handleRemoveImage = () => {
    setPlanData((prev) => ({
      ...prev,
      file: null
    }));
    setImagePreview(null);
  };

  const handleBulletPointInputChange = (e) => {
    setBulletPointInput(e.target.value);
  };

  const addBulletPoint = () => {
    if (bulletPointInput.trim()) {
      setPlanData((prev) => ({
        ...prev,
        bulletPoints: [...prev.bulletPoints, bulletPointInput.trim()]
      }));
      setBulletPointInput('');
    }
  };

  const removeBulletPoint = (index) => {
    setPlanData((prev) => ({
      ...prev,
      bulletPoints: prev.bulletPoints.filter((_, i) => i !== index)
    }));
  };

  const handleAdditionalImagesChange = (e) => {
    const files = Array.from(e.target.files);
    setPlanData((prev) => ({
      ...prev,
      additionalImages: [...prev.additionalImages, ...files]
    }));

    const previewUrls = files.map((file) => URL.createObjectURL(file));
    setAdditionalImagePreviews((prev) => [...prev, ...previewUrls]);
  };

  const removeAdditionalImage = (index) => {
    const newFiles = [...planData.additionalImages];
    newFiles.splice(index, 1);
    setPlanData((prev) => ({
      ...prev,
      additionalImages: newFiles
    }));

    const newPreviews = [...additionalImagePreviews];
    newPreviews.splice(index, 1);
    setAdditionalImagePreviews(newPreviews);
  };

  const uploadAdditionalImages = async (files) => {
    const uploadedUrls = [];
    for (const file of files) {
      const formdata = new FormData();
      formdata.append('images', file);

      const requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow'
      };

      try {
        const response = await fetch(
          'https://file-upload-ashen.vercel.app/api/upload',
          requestOptions
        );
        const result = await response.text();
        const data = JSON.parse(result);
        if (data?.success === true) {
          uploadedUrls.push(data?.data);
        } else {
          toast.error('Error uploading additional images');
          return null;
        }
      } catch (error) {
        console.error(error);
        toast.error('Error uploading additional images');
        return null;
      }
    }
    return uploadedUrls;
  };

  const bannerSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);

    let uploadedImageUrl = null;
    let additionalImageUrls = [];

    try {
      // Upload main image if updated
      if (planData.file) {
        const formData = new FormData();
        formData.append('images', planData.file);

        const requestOptions = {
          method: 'POST',
          body: formData,
          redirect: 'follow'
        };

        const response = await fetch(
          'https://file-upload-ashen.vercel.app/api/upload',
          requestOptions
        );
        const result = await response.text();
        const data = JSON.parse(result);

        if (data?.success) {
          uploadedImageUrl = data?.data[0];
        } else {
          toast.error('Error uploading main image');
          setLoader(false);
          return;
        }
      }

      const rawData = {};
      if (planData.name !== getData.name) rawData.name = planData.name;
      if (planData.courseDuration !== getData.duration)
        rawData.duration = Number(planData.courseDuration);
      if (planData.timePeriod !== getData.periodType) rawData.periodType = planData.timePeriod;
      if (planData.description !== getData.description) rawData.description = planData.description;
      if (planData.category !== getData.category) rawData.category = planData.category;
      if (planData.youtubeVideoLink !== getData.youtubeVideoLink)
        rawData.youtubeVideoLink = planData.youtubeVideoLink;
      if (planData.price !== getData.price) rawData.price = Number(planData.price);
      if (planData.lessons !== getData.lesson) rawData.lesson = planData.lessons;
      if (JSON.stringify(planData.bulletPoints) !== JSON.stringify(getData.bulletPoints))
        rawData.bulletPoints = planData.bulletPoints;
      if (uploadedImageUrl) rawData.image = uploadedImageUrl;
      if (additionalImageUrls.length > 0) rawData.additionalImages = additionalImageUrls;
      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      myHeaders.append('Accept', 'application/json');
      myHeaders.append('Access-Control-Allow-Origin', '*');
      myHeaders.append('Authorization', `Bearer ${localStorage.getItem('token')}`);

      const requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: JSON.stringify(rawData),
        redirect: 'follow'
      };

      const courseResponse = await fetch(
        `https://quran-backend-theta.vercel.app/v1/admin/course/${getData?._id}`,
        requestOptions
      );
      const courseResult = await courseResponse.text();
      const courseData = JSON.parse(courseResult);

      if (courseData?.success === false) {
        if (courseData?.message === 'Expired') {
          localStorage.clear();
          window.location.reload();
        } else {
          toast.error(courseData?.message);
        }
      } else {
        toast.success('Course updated successfully!');
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
      toast.error('An error occurred');
    } finally {
      setLoader(false);
    }
  };

  const [tab, setTabs] = useState('details');

  return (
    <div>
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <div className="p-3 flex justify-between items-center">
          <span></span>
          <h1 className="capitalize h4 font-medium">Update Course Details</h1>
          <MdClose onClick={() => setIsModalOpen(false)} size={25} />
        </div>
        <hr />
        <ul className=" mt-6 px-5 flex w-full gap-4 border-b">
          <li className=" cursor-pointer" onClick={() => setTabs('details')}>
            <span
              className={` ${
                tab === 'details' ? 'text-[#FF7E00] border-b-2 border-[#FF7E00]' : 'text-gray-400'
              } `}
            >
              Details
            </span>
          </li>
          <li className="cursor-pointer" onClick={() => setTabs('documents')}>
            <span
              className={` ${
                tab === 'documents' ? 'text-[#FF7E00] border-b-2 border-[#FF7E00]' : 'text-gray-400'
              } `}
            >
              Documents
            </span>
          </li>
          <li className="cursor-pointer" onClick={() => setTabs('sale')}>
            <span
              className={` ${
                tab === 'sale' ? 'text-[#FF7E00] border-b-2 border-[#FF7E00]' : 'text-gray-400'
              } `}
            >
              Sale
            </span>
          </li>
        </ul>
        {tab === 'details' ? (
          <div className="p-5">
            <form onSubmit={bannerSubmit}>
              <div className="flex gap-5 flex-wrap">
                <div className="w-[48%]">
                  <Input
                    label={'Course Name'}
                    placeholder={'name'}
                    className={'bg-gray-100 px-2 w-full'}
                    name="name"
                    value={planData.name}
                    onChange={handleChange}
                  />
                </div>

                <div className="w-[48%]">
                  <label className="block mb-2 text-sm text-gray-900 font-medium">
                    Course Category
                  </label>
                  <select
                    name="category"
                    value={planData.category}
                    onChange={handleChange}
                    className="w-full py-3 outline-none bg-lightGray p-2.5 text-black placeholder:text-primary rounded-md"
                  >
                    <option>Select Category</option>
                    {category?.map((item, index) => (
                      <option key={index} value={item?._id}>
                        {item?.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="w-[48%]">
                  <label className="block mb-2 text-sm text-gray-900 font-medium">Duration</label>
                  <select
                    name="courseDuration"
                    value={planData.courseDuration}
                    onChange={handleChange}
                    className="w-full py-3 outline-none bg-lightGray p-2.5 text-black placeholder:text-primary rounded-md"
                  >
                    <option>Select Duration</option>
                    {[...Array(12).keys()].map((i) => (
                      <option key={i} value={i + 1}>
                        {i + 1}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="w-[48%]">
                  <label className="block mb-2 text-sm text-gray-900 font-medium">
                    Period Type
                  </label>
                  <select
                    name="timePeriod"
                    value={planData.timePeriod}
                    onChange={handleChange}
                    className="w-full py-3 outline-none bg-lightGray p-2.5 text-black placeholder:text-primary rounded-md"
                  >
                    <option>Select Type</option>
                    <option value="month">Month</option>
                    <option value="year">Year</option>
                  </select>
                </div>

                <div className="w-[100%]">
                  <Input
                    label={'Lessons'}
                    placeholder={'Enter number of lessons'}
                    className={'bg-gray-100 px-2 w-full'}
                    name="lessons"
                    value={planData.lessons}
                    onChange={handleChange}
                  />
                </div>

                <div className="w-[100%]">
                  <Input
                    label={'Price'}
                    placeholder={'Enter price'}
                    className={'bg-gray-100 px-2 w-full'}
                    name="price"
                    value={planData.price}
                    onChange={handleChange}
                    type="number"
                  />
                </div>

                <div className="w-[100%]">
                  <label>Description</label>
                  <textarea
                    rows={5}
                    className="w-full bg-[#F6F6F6] py-3 px-5"
                    name="description"
                    value={planData.description}
                    onChange={handleChange}
                  ></textarea>
                </div>

                <div className="w-[100%]">
                  <Input
                    label={'Youtube Video Link'}
                    placeholder={'Enter Link'}
                    className={'bg-gray-100 px-2 w-full'}
                    name="youtubeVideoLink"
                    value={planData.youtubeVideoLink}
                    onChange={handleChange}
                    type="url"
                  />
                </div>

                <div className="w-[100%]">
                  <label>Bullet Points</label>
                  <div className="flex gap-2">
                    <input
                      type="text"
                      value={bulletPointInput}
                      onChange={handleBulletPointInputChange}
                      className="w-full bg-[#F6F6F6] py-3 px-5"
                      placeholder="Enter a bullet point"
                    />
                    <button
                      type="button"
                      onClick={addBulletPoint}
                      className=" bg-secondary text-white px-4 py-2 rounded-md"
                    >
                      Add
                    </button>
                  </div>
                  <div className="mt-2">
                    {planData.bulletPoints.map((point, index) => (
                      <div key={index} className="flex items-center gap-2">
                        <span>{point}</span>
                        <button
                          type="button"
                          onClick={() => removeBulletPoint(index)}
                          className="text-red-500"
                        >
                          <MdClose size={16} />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>

                <div
                  className="w-full border-dashed border-[#9E9E9E] bg-[#F6F6F6] border-2 rounded-lg p-4 cursor-pointer"
                  onClick={handleClick}
                >
                  <div className="bg-[#F6F6F6] mx-auto w-14 flex justify-center items-center h-20 rounded-2xl">
                    <MdOutlineFileUpload size={30} className="text-primary" />
                  </div>
                  <p className="text-primary font-medium mt-3 text-center">
                    <span className="text-secondary">Click here</span> to upload or drop CNIC
                  </p>

                  {imagePreview && (
                    <div className="relative w-full h-32 mt-4">
                      <img
                        src={imagePreview}
                        alt="Selected Image"
                        className="w-full h-full object-cover rounded-md"
                      />
                      <button
                        type="button"
                        onClick={handleRemoveImage}
                        className="absolute top-0 right-0 bg-red-500 text-white p-2 rounded-full"
                      >
                        <MdClose size={20} />
                      </button>
                    </div>
                  )}
                  <input
                    id="fileInput"
                    type="file"
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                  />
                </div>
              </div>

              {loading ? (
                <button
                  disabled
                  type="button"
                  className="bg-primary w-full text-center mt-3 py-2.5 rounded-lg text-white font-semibold cursor-pointer"
                >
                  Loading...
                </button>
              ) : (
                <button
                  type="submit"
                  className={`w-full mt-3  bg-secondary py-2.5 rounded-md text-white text-sm font-medium ${
                    !isFormValid() && 'cursor-not-allowed opacity-50'
                  }`}
                  disabled={!isFormValid()}
                >
                  Update Course
                </button>
              )}
            </form>
          </div>
        ) : tab === 'documents' ? (
          <Addnotes />
        ) : (
          <AddSale />
        )}
      </Modal>
    </div>
  );
};

export default UpdateCources;
